// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"style_cardWrap__3m32I","formWarp":"style_formWarp__3ODGT","forgotPw":"style_forgotPw__2DKjc","subTitle":"style_subTitle__2_YLV"};